import { defineStore } from 'pinia';
import { GQT_ACCOUNTING, GQT_ADMIN, GQT_AIR, GQT_ASM, GQT_COMMERCIAL, GQT_COORDINATOR, GQT_CRUISE, GQT_INCENTIVE, GQT_MARKETING, GQT_REVENUE, GQT_SUPERVISOR, GQT_SUPPORT } from '@/constants';
import UserAuthorizationsService from '@/service/UserAuthorizationsService';

export const useUserAuthorizationsStore = defineStore('userAuthorizationsStore', {
  state: () => ({
    listRolePermission: {},
    permissionByRole: {}
  }),
  getters: {},

  actions: {
    async getListRolePermision() {
      const Service = new UserAuthorizationsService();
      const res = await Service.getListRolePerMission();
      this.listRolePermission = res?.data;
      return res?.data;
    },

    async getListPermissionByRole(role: any) {
      const Service = new UserAuthorizationsService();
      const res = await Service.getPermissionByRole(role);
      const permissions = this.getDetailPermissionByRole(role, res?.data);
      this.permissionByRole = this.getActivePermission(permissions);
      return this.permissionByRole;
    },

    async updatePermission(body) {
      const Service = new UserAuthorizationsService();
      const res = await Service.updatePermissionRole(body);
      return res;
    },

    resetRolePermission() {
      this.permissionByRole = {};
    },

    getDetailPermissionByRole(role: any, data: any) {
      switch (role) {
        case GQT_ADMIN:
          return data.admin;
        case GQT_COORDINATOR:
          return data.co;
        case GQT_REVENUE:
          return data.rm;
        case GQT_ASM:
          return data.asm;
        case GQT_COMMERCIAL:
          return data.gc;
        case GQT_ACCOUNTING:
          return data.accounting;
        case GQT_AIR:
          return data.ao;
        case GQT_CRUISE:
          return data.cr;
        case GQT_INCENTIVE:
          return data.in;
        case GQT_MARKETING:
          return data.marketing;
        case GQT_SUPPORT:
          return data.support;
        case GQT_SUPERVISOR:
          return data.su;
        default:
          return data.tagent;
      }
    },

    getActivePermission(permissions: any) {
      return Object.fromEntries(Object.entries(permissions).map(([key, value]) => [key, value && typeof value === 'object' ? Object.fromEntries(Object.entries(value).filter(([, permission]) => permission)) : {}]));
    }
  }
});
